import { render, staticRenderFns } from "./RateShow.vue?vue&type=template&id=2f11c6f5"
import script from "./RateShow.vue?vue&type=script&lang=js"
export * from "./RateShow.vue?vue&type=script&lang=js"
import style0 from "./RateShow.vue?vue&type=style&index=0&id=2f11c6f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports